import { ArrayUtils, engineComponent, StringUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { HtmlController } from "../HTMLComponents/HtmlController";
import { HtmlContainerElement } from "../HTMLComponents/Elements/HtmlContainerElement";
import { IButtonElement } from "./IButtonElement";
import { LayoutSwitchElement } from "./LayoutSwitchElement";

@engineComponent(ComponentTypes.DisplayObject)
export class ActionSwitchElement extends LayoutSwitchElement implements IButtonElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private static readonly ON_CLICK: string = "pointerdown";

    private _actionId: string;

    //******************************************************************************************************************
    //  OVERRIDES
    //******************************************************************************************************************

    createByNode(node: Element): void {
        super.createByNode(node);

        if (node.hasAttribute(ActionSwitchElementAttributes.ACTION)) {
            this._actionId = node.getAttribute(ActionSwitchElementAttributes.ACTION);
            HtmlController.registerActionElement(node.getAttribute("Action"), this);

            this.on(ActionSwitchElement.ON_CLICK, this.onClick.bind(this));
        }

        if (
            node.hasAttribute(ActionSwitchElementAttributes.HIT_AREA) &&
            node.hasAttribute(ActionSwitchElementAttributes.HIT_AREA_DATA)
        ) {
            let type = node.getAttribute(ActionSwitchElementAttributes.HIT_AREA);
            let data = node.getAttribute(ActionSwitchElementAttributes.HIT_AREA_DATA);
            this.createHitArea(type, data);
        }
    }

    /*goToCase(s: string, emitEvent: boolean = false): void {

        this.interactive = true;
        this.buttonMode = true;

        if (this.style != null && this.style.cases != null && this.case !== s) {
            if (this.hasCase(s)) {
                let node: Element = this.style.cases[s];

                if (node.hasAttribute(ActionSwitchElementAttributes.INTERACTIVE)) {
                    let interactive = StringUtils.parseBoolean(node.getAttribute(ActionSwitchElementAttributes.INTERACTIVE));
                    this.interactive = interactive;
                    this.buttonMode = interactive;
                }
            }
        }

        super.goToCase(s, emitEvent);
    }*/

    private createHitArea(type: string, data: string): void {
        switch (type) {
            case "Rectangle":
                this.createRectangleHitArea(data);
                break;
            case "Circle":
                this.createCircleHitArea(data);
                break;
            case "Ellipse":
                this.createEllipseHitArea(data);
                break;
            case "Polygon":
                this.createPolygonHitArea(data);
                break;
            case "RoundedRectangle":
                this.createRoundedRectangleHitArea(data);
                break;
            default:
                this.createRectangleHitArea(data);
        }
    }

    private createRectangleHitArea(data: string): void {
        let sizeArray = data.split(";");
        if (sizeArray.length == 2) {
            this.hitArea = new PIXI.Rectangle(0, 0, parseInt(sizeArray[0]), parseInt(sizeArray[1]));
        }
    }

    private createCircleHitArea(data: string): void {
        //ToDo
    }

    private createEllipseHitArea(data: string): void {
        //ToDo
    }

    private createPolygonHitArea(data: string): void {
        const path = ArrayUtils.stringArray(data, "|");
        let points: PIXI.Point[] = [];
        for (let i = 0; i < path.length; i++) {
            const point = ArrayUtils.numberArray(path[i]);
            points.push(new PIXI.Point(point[0], point[1]));
        }

        this.hitArea = new PIXI.Polygon(points);
    }

    private createRoundedRectangleHitArea(data: string): void {
        //ToDo
    }

    onClick(): void {
        if (this._actionId != null) {
            HtmlController.dispatchAction(this._actionId);
        }
    }

    changeState(value: boolean): void {
        this.interactive = value;
        this.buttonMode = value;
    }

    clone(): ActionSwitchElement {
        const element: ActionSwitchElement = new ActionSwitchElement();

        element.style = this.style;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;
        if (this.maskSprite != null) {
            let elementMask = new PIXI.Sprite((<PIXI.Sprite>this.maskSprite).texture);
            elementMask.position.x = this.maskSprite.position.x;
            elementMask.position.y = this.maskSprite.position.y;

            elementMask.pivot.x = this.maskSprite.pivot.x;
            elementMask.pivot.y = this.maskSprite.pivot.y;

            elementMask.scale.x = this.maskSprite.scale.x;
            elementMask.scale.y = this.maskSprite.scale.y;

            element.maskSprite = elementMask;
            element.addChild(elementMask);
            element.mask = elementMask;
        } else if (this.maskGraphics != null) {
        }

        element.elements = this.elements.clone();
        element.addChild(element.elements);

        element.case = this.case;
        element._actionId = this._actionId;

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}

const ActionSwitchElementAttributes = {
    ACTION: "Action",
    HIT_AREA: "HitArea",
    HIT_AREA_DATA: "HitAreaData",
    INTERACTIVE: "Interactive",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ActionSwitchElement.ts
 **/